<template>
  <component
    :is="isMegaMenuMobile ? LazyCmsMegaMenuL2Mobile : LazyCmsMegaMenuL2Desktop"
    v-bind="{ content }"
    @click="handleClick"
    @expand="handleExpand"
  />
</template>

<script lang="ts" setup>
import type { MegaMenuL1Context } from '#content/contexts/megamenu'
import type { MenuItem } from '#types/components/cms/mega-menu'
import { LazyCmsMegaMenuL2Desktop, LazyCmsMegaMenuL2Mobile } from '#components'
import { MegaMenuL1ContextKey, MegaMenuL2ContextKey, MegaMenuMobileContextKey } from '#content/contexts/megamenu'

const props = defineProps<{
  content: MenuItem
}>()

const { $gtm } = useNuxtApp()
const { getActionLinkHandler, isActionLinkOnly } = useCmsActionLink('header:mega-menu')

const eventLabel = formatMegaMenuLevelLabel(getMegaMenuItemLabel(props.content), 2)

const isMegaMenuMobile = inject(MegaMenuMobileContextKey, false)
const { l1 } = inject(MegaMenuL1ContextKey, {} as MegaMenuL1Context)

provide(MegaMenuL2ContextKey, { featured: props.content.menuStyle === 'featured', title: eventLabel })

const handleClick = () => {
  if (isActionLinkOnly(props.content.target))
    getActionLinkHandler(props.content.target, getMegaMenuItemLabel(props.content))?.()
  $gtm.push('topNav.onClickTopNavLink', `${toValue(l1)} | ${eventLabel}`)
}
const handleExpand = () => $gtm.push('topNav.onClickMobileMenuSection', `${toValue(l1)} | ${eventLabel}`)
</script>
